const eventMethod   = window.addEventListener ? 'addEventListener' : 'attachEvent';

const isAttachEventAvailable = () => eventMethod === 'attachEvent';

const keypressEvent = isAttachEventAvailable() ? 'onkeypress' : 'keypress';
const keyupEvent    = isAttachEventAvailable() ? 'onkeyup' : 'keyup';
const keydownEvent  = isAttachEventAvailable() ? 'onkeydown' : 'keydown';
const submitEvent   = isAttachEventAvailable() ? 'onsubmit' : 'submit';
const blurEvent     = isAttachEventAvailable() ? 'onblur' : 'blur';
const messageEvent  = isAttachEventAvailable() ? 'onmessage' : 'message';

export {
  eventMethod,
  keypressEvent,
  keyupEvent,
  keydownEvent,
  submitEvent,
  blurEvent,
  messageEvent,
};



// WEBPACK FOOTER //
// ./src/common/utils/EventUtils.js